import { Box, Typography } from '@mui/material';
import { type JSX } from 'react';

import { WhiteButton } from 'app/shared-components/buttons';
import useEventTracker from 'app/hooks/useEventTracker';
import { BILLING_AND_REPORTS_EVENTS } from 'app/tracking/constants';
import ExternalLinkIcon from 'app/assets/icons/external-link.svg?react';

import config from '@/config.json';

export default function SubscriptionManagementCard(): JSX.Element {
  const trackEvent = useEventTracker('Billing and Reports');

  const openPortal = (): void => {
    const event = BILLING_AND_REPORTS_EVENTS.MANAGE_PAYMENT_CLICKED;
    trackEvent(event.action, event);
    window.open(createPortalLink(config.chargebeeSite), '_blank', 'noopener,noreferrer');
  };

  return (
    <Box className="flex items-center justify-between p-16 bg-white rounded-lg border border-border">
      <Box>
        <Typography variant="subtitle1" className="font-600 text-typography-primary">
          My subscription details
        </Typography>
        <Typography variant="body2" className="text-typography-secondary">
          View and manage your organisation subscription.
        </Typography>
      </Box>
      <WhiteButton
        label="View"
        cb={openPortal}
        icon={<ExternalLinkIcon width={13} height={13} />}
      />
    </Box>
  );
}

function createPortalLink(site: string): string {
  return `https://${site}.chargebeeportal.com`;
}
